import { platformApi } from "@/api/http";

export interface Gender {
  id: number;
  name: string;
}

function parseGendersResponse(data: unknown): Gender[] {
  if (Array.isArray(data)) return data as Gender[];
  if (data && typeof data === "object") {
    const body = data as Record<string, unknown>;
    const arr =
      (body.genders as Gender[] | undefined) ??
      (body.data as Gender[] | undefined) ??
      (body.items as Gender[] | undefined) ??
      (body.results as Gender[] | undefined) ??
      [];
    return Array.isArray(arr) ? arr : [];
  }
  return [];
}

/** GET /api/v1/genders */
export async function getGenders(): Promise<Gender[]> {
  const { data } = await platformApi.get<unknown>("/api/v1/genders");
  return parseGendersResponse(data);
}
